import * as React from 'react'
import { connect } from 'react-redux'

import { getForm } from '../../actions/forms'
import { getAnswerCustomFormField } from '../../lib/form/answer-custom-form-fields'
import { FormBuilder } from '../../lib/form-builder/formbuilder-loadable'
import { HubItem } from '../../reducers/hub'
import { formSelector } from '../../selectors/forms'
import { hubSelector } from '../../selectors/hub'
import { companyNameSelector } from '../../selectors/widget'
import { RootState } from '../../types/rootstate'
import { BrandingIcon } from '../branding'
import { Container } from '../container'
import { Header } from './header'

import '../../sass/answers/main.scss'
import '../../sass/grid12.scss'

interface StateProps {
  form: RootState['forms']['key']
  userId: number
  agentId: number
  companyName: string
  hub: HubItem[]
}

interface DispatchProps {
  getForm: (userId: number, agentId: number, formId: number) => void
}

interface OwnProps {
  params
}

type MainProps = StateProps & DispatchProps & OwnProps

function mapStateToProps(state: RootState, ownProps: OwnProps): StateProps {
  return {
    form: formSelector(state, ownProps.params.formId),
    userId: state.widget.userId,
    agentId: state.widget.agentId,
    companyName: companyNameSelector(state),
    hub: hubSelector(state),
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {
    getForm: (userId, agentId, formId) =>
      dispatch(getForm(userId, null, formId)),
  }
}

interface MainState {}

class MainComponent extends React.Component<MainProps, MainState> {
  references: {
    container: HTMLDivElement
  } = {
    container: null,
  }

  componentWillMount(): void {
    if (!this.props.form) {
      this.props.getForm(
        this.props.params.userId,
        this.props.agentId,
        this.props.params.formId
      )
    }
  }

  componentWillReceiveProps(nextProps): void {
    if (this.props.params.formId !== nextProps.params.formId) {
      this.props.getForm(
        nextProps.params.userId,
        nextProps.agentId,
        nextProps.params.formId
      )
    }
  }

  render(): JSX.Element {
    const hasForm = this.props.form && this.props.form.status === 'success'
    const hasFooter =
      hasForm &&
      this.props.form.form.some(
        (form) => form.field_type === 'formButton' && form.sticky === '1'
      )

    return (
      <Container name="answers">
        <Header />
        <div
          className={'answers-dynamic-frame' + (hasFooter ? ' has-footer' : '')}
        >
          <div className="answers-main container">
            <div className="row">
              {hasForm && (
                <FormBuilder
                  form={this.props.form.form}
                  instanceId="answers-main"
                  formId={this.props.params.formId}
                  companyName={this.props.companyName}
                  onSubmit={(): void => {
                    // no-op
                  }}
                  customFormField={(field, index) =>
                    getAnswerCustomFormField(
                      this.props.params.userId,
                      this.props.params.formId,
                      field,
                      index
                    )
                  }
                />
              )}
            </div>
          </div>

          <BrandingIcon type="answers" />
        </div>
      </Container>
    )
  }
}

const Main = connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(MainComponent)

export { Main }
